const REVEAL_SELECTOR = '.reveal-fade-up, .reveal-fade-left, .reveal-fade-right, .reveal-words'
const WORD_CLASS = 'reveal-word'
const GROUP_STAGGER_MS = 70

const splitWords = element => {
  if (! element || element.dataset.revealWordsReady === 'true') {
    return
  }

  const text = element.textContent

  if (! text || ! text.trim()) {
    return
  }

  const words = text.trim().split(/\s+/)
  const fragment = document.createDocumentFragment()

  words.forEach((word, index) => {
    const outer = document.createElement('span')
    const inner = document.createElement('span')

    outer.className = `${WORD_CLASS}-outer`
    inner.className = WORD_CLASS
    inner.textContent = word
    outer.appendChild(inner)
    fragment.appendChild(outer)

    if (index < words.length - 1) {
      fragment.appendChild(document.createTextNode(' '))
    }
  })

  element.textContent = ''
  element.appendChild(fragment)
  element.dataset.revealWordsReady = 'true'
}

const revealElement = (element, delayMs = 0) => {
  window.setTimeout(() => {
    window.requestAnimationFrame(() => {
      element.classList.add('is-revealed')
    })
  }, delayMs)
}

const groupElementsByParent = elements => {
  const groups = new Map()

  elements.forEach(element => {
    const parent = element.parentElement

    if (! parent) {
      return
    }

    if (! groups.has(parent)) {
      groups.set(parent, [])
    }

    groups.get(parent).push(element)
  })

  return groups
}

const initScrollReveal = () => {
  const elements = Array.from(document.querySelectorAll(REVEAL_SELECTOR))

  if (elements.length === 0) {
    return
  }

  elements.forEach(element => {
    if (element.classList.contains('reveal-words')) {
      splitWords(element)
    }
  })

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  if (reduceMotion || typeof IntersectionObserver === 'undefined') {
    elements.forEach(revealElement)
    return
  }

  const groups = groupElementsByParent(elements)

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (! entry.isIntersecting) {
        return
      }

      const children = groups.get(entry.target) || []

      children.forEach((element, index) => {
        const delayMs = index * GROUP_STAGGER_MS
        element.style.setProperty('--reveal-auto-delay', `${delayMs}ms`)
        revealElement(element, 16)
      })

      observer.unobserve(entry.target)
    })
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -8% 0px',
  })

  groups.forEach((_, parent) => {
    observer.observe(parent)
  })
}

export default initScrollReveal



// WEBPACK FOOTER //
// ./resources/assets/js/components/scroll-reveal.js